import { ChangeDetectionStrategy, Component, effect, inject, input, OnDestroy, OnInit, output, signal } from '@angular/core';
import { Subscription } from 'rxjs';
import { CurrentUserService } from '../../../../common/current-user/current-user.service';
import { UgcProductResponseDto } from '../../../../common/general-types/products.dto';
import { ImageService } from '../../../../services/image/image.service';
import { ProductService } from '../../../../services/product/product.service';
import { BrandProductsCreateComponent } from '../../../my-brand/molecules/brand-products-create/brand-products-create.component';
import { productPriceLabel } from './a-product.helpers';

@Component({
  selector: 'cbss-product',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BrandProductsCreateComponent],
  templateUrl: './a-product.html',
  styleUrl: './a-product.scss',
})
export class CreateBriefSelectSmartProduct implements OnInit, OnDestroy {
  readonly chosen = output<UgcProductResponseDto>();
  readonly createClosed = output<void>();
  readonly createOnOpen = input(false);
  readonly products = signal<UgcProductResponseDto[]>([]);
  readonly loading = signal(true);
  readonly creating = signal(false);

  readonly imageService = inject(ImageService);
  private readonly subscriptionList = new Subscription();
  private readonly productService = inject(ProductService);
  private readonly currentUserService = inject(CurrentUserService);

  constructor() {
    effect(() => {
      if (this.createOnOpen()) {
        this.creating.set(true);
      }
    });
  }

  ngOnInit(): void {
    const brandId = this.currentUserService.focussedBrand?.id as string | undefined;
    if (!brandId) {
      this.loading.set(false);
      return;
    }

    this.subscriptionList.add(
      this.productService.getbusinessProducts(brandId).subscribe({
        next: (response: unknown) => {
          this.products.set(Array.isArray(response) ? response as UgcProductResponseDto[] : []);
          this.loading.set(false);
        },
        error: () => this.loading.set(false),
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptionList.unsubscribe();
  }

  price(product: UgcProductResponseDto): string {
    return productPriceLabel(product.productValue, product.currency);
  }

  choose(product: UgcProductResponseDto): void {
    this.chosen.emit(product);
  }

  startCreate(): void {
    this.creating.set(true);
  }

  cancelCreate(): void {
    this.creating.set(false);
    this.createClosed.emit();
  }

  onCreated(product: UgcProductResponseDto): void {
    this.products.update((list) => [product, ...list]);
    this.creating.set(false);
    this.createClosed.emit();
    this.chosen.emit(product);
  }
}
